import React from 'react'
import {Image} from 'antd';
import Img1 from "./guanmu1.jpg"
import Img2 from "./guanmu2.jpg"
import Img3 from "./guanmu3.jpg"
import Img4 from "./guanmu4.jpg"
import Img5 from "./guanmu5.jpg"
const width = 1280;

export default function Guanmu() {
  return (
    <Image.PreviewGroup>
    <Image width={width} src={Img1} />
    <Image width={width} src={Img2} />
    <Image width={width} src={Img3} />
    <Image width={width} src={Img4} />
    <Image width={width} src={Img5} />
    </Image.PreviewGroup>
  )
}